<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline mr-4">
            <v-icon class="pr-2">add_circle</v-icon>
            Apply Promo Code
          </span>
          <v-btn absolute right depressed flat fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="apply_coupon" data-vv-scope="apply_coupon" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="form.name"
                  label="Promo Code*"
                  v-validate="'required|min:2'"
                  data-vv-name="apply_coupon.name"
                  :error-messages="errors.collect('apply_coupon.name')"
                  required
                  @keyup.enter="applyCoupon()"
                ></v-text-field>
              </v-flex>
            </v-layout>
            </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="applyCoupon()" :loading="loading" :disabled="loading">Apply</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'ApplyCouponModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['applyCouponDialog'],
  data () {
    return {
      dialog: this.applyCouponDialog,
      loading: false,
      form: {
        name: ''
      },
      dictionary: {
        en: {
          custom: {
            'apply_coupon.name': {
              required: 'Promo Code required',
              min: 'Required at least 2 symbols'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  watch: {
    applyCouponDialog: {
      handler () {
        this.dialog = this.applyCouponDialog
      }
    },
    dialog: {
      handler () {
        this.$eventEmitter.$emit('applyCouponDialog', this.dialog)
      }
    }
  },
  methods: {
    applyCoupon () {
      this.$validator.validateAll('apply_coupon').then(res => {
        if (res) {
          this.loading = true
          this.$store.dispatch('APPLY_COUPON', this.form.name).then(res => {
            this.loading = false
            this.$store.dispatch('GET_USER_DATA')
            // this.$eventEmitter.$emit('updatePackagesList')
            this.$eventEmitter.$emit('updateWizardPrice')
            this.$toasted.show('Promo Code was successfully applied')
            // if (!['Subscriptions', 'SubscriptionSettings'].includes(this.$router.name)) this.$router.push({ name: 'Subscriptions' })
            this.closeModal()
          }, err => {
            console.log('APPLY_COUPON error', err)
            this.loading = false
            let errorText = this.$services.getApiError(err)
            if (err.status === 400 || err.status === 404) {
              if (errorText) this.$toasted.show('Failed to apply Promo Code: ' + errorText, {duration: 10000, type: 'error'})
            } else {
              if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
            }
          })
        }
      })
    },
    closeModal () {
      this.dialog = false
      this.clearForm()
    },
    clearForm () {
      this.form = {
        name: ''
      }
      setTimeout(() => {
        this.$validator.errors.clear('apply_coupon')
      }, 500)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/coupon/ApplyCouponModal.vue